import CosmosAdminDbRecordBase from '@/models/CosmosAdminDbRecordBase'
import moment from 'moment'

export default class IncidentManagerShiftTimeModel extends CosmosAdminDbRecordBase {
  public userId: string
  public startTime: moment.Moment | null
  public endTime: moment.Moment | null
  public canQuinyxPunch: boolean | false
}
